import apiUrls from '../../youwell-common/apiUrls';
import ReduxStoreHelper from '../../youwell-common/ReduxStoreHelper';

import { PREVIEW_ACTION_PREFIX as ACTION_PREFIX } from './actions';
import { parseInsertedResponse } from '../../youwell-common/responseUtils';

const PREVIEW_RESPONSE_INSERTED = 'PREVIEW_RESPONSE_INSERTED';
const PREVIEW_START_COMMENT = 'PREVIEW_START_COMMENT';
const PREVIEW_TOGGLE_COMMENTS = 'PREVIEW_TOGGLE_COMMENTS';
const SAVE_COMMENT = 'PREVIEW_SAVE_COMMENT';
const PREVIEW_CLEAR_COMMENT_ELEMENT = 'PREVIEW_CLEAR_COMMENT_ELEMENT';
const GET_COMMENTS = 'PREVIEW_GET_COMMENTS';

const storeHelper = new ReduxStoreHelper(ACTION_PREFIX);

export const actionCreators = {
    ...storeHelper.defaultActionCreators(apiUrls.app.preview),
    updateResponse: data => (dispatch) => {
        dispatch({ type: PREVIEW_RESPONSE_INSERTED, data });
    },
    toggleComments: () => (dispatch) => {
        dispatch({ type: PREVIEW_TOGGLE_COMMENTS });
    },
    startComment: data => (dispatch) => {
        dispatch({ type: PREVIEW_START_COMMENT, data });
    },
    getTaskComments: storeHelper.createGetElementActionCreator(`${apiUrls.app.preview}/comments`, GET_COMMENTS),
    saveTaskComment: storeHelper.createInsertActionCreator(`${apiUrls.app.preview}/comment`, SAVE_COMMENT),
    clearCommentElement: () => (dispatch) => {
        dispatch({ type: PREVIEW_CLEAR_COMMENT_ELEMENT });
    },
};

const initialState = {
    ...storeHelper.defaultInitialState,
    commentElementId: null,
    showComments: false,
    responses: {},
    comments: {},
};

export const reducer = (state, action) => {
    switch (action.type) {
    case PREVIEW_RESPONSE_INSERTED: {
        const { taskId } = action.data;

        const taskSubtotals = state.details?.[taskId]?.taskSubtotals || [];

        const responses = parseInsertedResponse(action.data, taskSubtotals, state.responses);

        return {
            ...state,
            responses,
        };
    }
    case PREVIEW_TOGGLE_COMMENTS: {
        return {
            ...state,
            showComments: !state.showComments,
        };
    }
    case `${ACTION_PREFIX}/${GET_COMMENTS}`: {
        return {
            ...state,
            comments: {
                ...state.comments,
                [action.reducerParams.taskId]: action.data,
            },
        };
    }
    case PREVIEW_START_COMMENT: {
        return {
            ...state,
            commentElementId: action.data.elementId,
            showComments: true,
        };
    }
    case PREVIEW_CLEAR_COMMENT_ELEMENT: {
        return {
            ...state,
            commentElementId: null,
        };
    }
    case `${ACTION_PREFIX}/${SAVE_COMMENT}`: {
        const currentComments = state.comments[action.inputData.taskId] || [];

        return {
            ...state,
            comments: {
                ...state.comments,
                [action.inputData.taskId]: [...currentComments, {
                    id: action.data.id, created: action.data.created, ...action.inputData,
                }],
            },
            commentElementId: null,
            showComments: true,
        };
    }
    default: {
        const stateFromDefaultActions = storeHelper.defaultReducer(state, action, initialState);

        if (stateFromDefaultActions !== null) {
            return stateFromDefaultActions;
        }

        return state || initialState;
    }
    }
};
